import DeviceInfo from "@/models/deviceInfo.model";
import ApiService from "@/services/api.service";

class DeviceService extends ApiService {
  constructor() {
    super();
  }

  public async getActive(): Promise<DeviceInfo[]> {
    const url = "/api/Device";
    const response = await this.axiosInstance.get<DeviceInfo[]>(url);
    return (response.data || []).map((item) => new DeviceInfo(item));
  }

  public async get(serialNumber: string): Promise<DeviceInfo> {
    const url = `/api/Device/${serialNumber}`;
    const response = await this.axiosInstance.get<DeviceInfo>(url);
    return new DeviceInfo(response.data);
  }

  public async startRecovery(serialNumber: string): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/recovery`;
    const response = await this.axiosInstance.patch(url);
    return response.status === 202;
  }

  public async stopRecovery(serialNumber: string): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/recovery`;
    const response = await this.axiosInstance.delete(url);
    return response.status === 202;
  }

  public async startIdentification(serialNumber: string): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/identification`;
    const response = await this.axiosInstance.patch(url);
    return response.status === 202;
  }

  public async stopIdentification(serialNumber: string): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/identification`;
    const response = await this.axiosInstance.delete(url);
    return response.status === 202;
  }

  public async requestLocation(serialNumber: string): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/requests/location`;
    const response = await this.axiosInstance.post(url);
    return response.status === 202;
  }

  public async setLifetime(serialNumber: string, lifetime: number): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/lifetime`;
    const response = await this.axiosInstance.patch(url, {
      lifetimeInYears: lifetime
    });
    return response.status === 202;
  }

  public async inviteActivatorApp(email: string): Promise<boolean> {
    const url = `/api/Activators/invite/${email}`;
    const response = await this.axiosInstance.post(url);
    return response.status === 200;
  }

  public async getLastLocations(serialNumber: string): Promise<any[]> {
    const url = `/api/Device/${serialNumber}/locations`;
    const response = await this.axiosInstance.get<any[]>(url);
    return response.data || [];
  }
  public async ChangeDeviceLabel(serialNumber: string, label: string): Promise<boolean> {
    const url = `/api/Device/${serialNumber}/label`;
    const response = await this.axiosInstance.patch(url, { label });
    return response.status === 202;
  }
}

export default new DeviceService();
